import { FormattedMessage } from 'react-intl';
import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { FilterChip } from './models/filter-chip';
import { PoolChip } from '../chip/pool-chip';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(),
    },
    legacy: {
        margin: '16px 62px 0px',
    },
    withinSubToolbar: {
        margin: '-16px 62px 24px',
    },
}));
interface PoolChipListProps {
    chips: FilterChip[];
    styleType?: keyof ReturnType<typeof useStyles>;
    onChipDelete: (propertyPaths: string | string[]) => void;
}

export const PoolChipList = (props: PoolChipListProps) => {
    const classes = useStyles();

    const onChipDelete = (propertyPaths: string | string[]) => {
        return () => {
            props.onChipDelete(propertyPaths);
        };
    };

    const styles = `${props.styleType ? classes[props.styleType] : ''} ${classes.root}`;

    if (props.chips.length > 0) {
        return (
            <div className={styles}>
                {props.chips.map((chip, index) => {
                    return (
                        <PoolChip
                            key={index}
                            type="primary"
                            filterItem={true}
                            onDelete={onChipDelete(chip.propertyPaths)}
                            label={
                                <FormattedMessage
                                    id={chip.id}
                                    values={{
                                        value: chip.value,
                                    }}
                                />
                            }
                        />
                    );
                })}
            </div>
        );
    }

    return null;
};
